/**
 * Centralized environment variable configuration.
 * All environment variables should be accessed through this module.
 * Required variables fall back to empty strings under Vitest so test files
 * that touch this module can still load without an `.env`.
 */

interface EnvConfig {
    SALES_URL: string;
    ENV: string;
    SUPABASE_API_KEY: string;

    isProduction: boolean;
    isStaging: boolean;
    isDev: boolean;
}

const isTestEnv = import.meta.env.MODE === "test" || import.meta.env.VITEST === true;

function getRequiredEnv(key: string): string {
    const value = import.meta.env[key];
    if (!value) {
        if (isTestEnv) return "";
        throw new Error(`[ENV] Missing required environment variable: ${key}`);
    }
    return value;
}

function createEnvConfig(): EnvConfig {
    const ENV = getRequiredEnv("VITE_ENV");

    return {
        SALES_URL: getRequiredEnv("VITE_SALES_URL"),
        ENV,
        SUPABASE_API_KEY: getRequiredEnv("VITE_SUPABASE_API_KEY"),

        isProduction: ENV === "production",
        isStaging: ENV === "staging",
        isDev: ENV === "development",
    };
}

export const env = createEnvConfig();
